export default "__VITE_ASSET__BX1spt0d__"